import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Location } from '@angular/common';
import { SessionStorageService } from '../services/session-storage.service';
import { DateTime } from 'luxon';
import { UtilityAppsService } from '../shared-components/utility-apps/utility-apps.service';
import { bmLinks } from '../lib/toolbar-links';
import { bmUtilityApps } from '../lib/utility-apps';

@Component({
  selector: 'app-carrier-portal',
  templateUrl: './carrier-portal.component.html',
  styleUrls: ['./carrier-portal.component.scss'],
  standalone: false,
})
export class CarrierPortalComponent implements OnInit, OnDestroy {
  private location = inject(Location);
  private ss = inject(SessionStorageService);
  private uas = inject(UtilityAppsService);

  navCollapsed = false;
  current = 'carrier-portal';
  minDate = DateTime.now().minus({ years: 1 }).startOf('month').toUTC().toISO();
  bmLinks = bmLinks;

  ngOnInit(): void {
    this.navCollapsed = this.ss.get('utilityToolbarCollapsed');
    this.current = this.location.path().split('/')[1] || 'carrier-portal';
    this.uas.appsList.set(bmUtilityApps);
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
  }

  toggleNavCollapse() {
    this.navCollapsed = !this.navCollapsed;
  }
}
